// extracted by mini-css-extract-plugin
export var aboveInput = "_lo-0";
export var actionButton = "_lo-5";
export var actionButtonContainer = "_lo-1";
export var actionIcon = "_lo-6";
export var aiInfoContainer = "_lo-2";
export var attachmentWrapper = "_lo-7";
export var bold = "_lo-3";
export var checkIcon = "_lo-8";
export var clickingRecipientBar = "_lo-11";
export var commentThreadSwitch = "_lo-a";
export var draftImage = "_lo-b";
export var draftImageContainer = "_lo-c";
export var draftImages = "_lo-e";
export var editButton = "_lo-g";
export var editor = "_lo-f";
export var editorContainer = "_lo-y";
export var editorErrorTooltipWrapper = "_lo-9";
export var headerDivider = "_lo-h";
export var icon = "_lo-i";
export var info = "_lo-j";
export var internal = "_lo-n";
export var internalDivider = "_lo-k";
export var internalMessage = "_lo-l";
export var messageInputCard = "_lo-m";
export var messageInputForm = "_lo-o";
export var messageInputFormInternal = "_lo-p";
export var options = "_lo-q";
export var publicMessageCustomer = "_lo-s";
export var publicMessageMerchant = "_lo-r";
export var removeImageButton = "_lo-d";
export var replyButtons = "_lo-t";
export var showSignatureButton = "_lo-u";
export var spinner = "_lo-v";
export var verticalButtonDivider = "_lo-4";
export var visibilitySelector = "_lo-w";
export var warning = "_lo-x";
export var wrappingText = "_lo-z";
export var writingInternalNoteTopBorder = "_lo-10";